import { useState, useEffect } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export const useBreakpoint = (): Breakpoint => {
    const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => {
        if (typeof window === 'undefined') return 'desktop';

        const width = window.innerWidth;
        if (width < 600) return 'mobile';
        if (width <= 960) return 'tablet'; // 960 is now tablet
        return 'desktop';
    });

    useEffect(() => {
        // Media Query Definitions
        const mobileQuery = window.matchMedia('(max-width: 599px)');
        // Tablet: from 600px up to AND including 960px
        const tabletQuery = window.matchMedia('(min-width: 600px) and (max-width: 960px)');
        // Desktop: anything from 961px and up
        const desktopQuery = window.matchMedia('(min-width: 961px)');

        const updateBreakpoint = () => {
            if (mobileQuery.matches) setBreakpoint('mobile');
            else if (tabletQuery.matches) setBreakpoint('tablet');
            else if (desktopQuery.matches) setBreakpoint('desktop');
        };

        // Modern browsers support addEventListener on MediaQueryList
        mobileQuery.addEventListener('change', updateBreakpoint);
        tabletQuery.addEventListener('change', updateBreakpoint);
        desktopQuery.addEventListener('change', updateBreakpoint);

        // Run once to sync state
        updateBreakpoint();

        return () => {
            mobileQuery.removeEventListener('change', updateBreakpoint);
            tabletQuery.removeEventListener('change', updateBreakpoint);
            desktopQuery.removeEventListener('change', updateBreakpoint);
        };
    }, []);

    return breakpoint;
};